import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip } from "reactstrap";
import { faCopy, faDownload, faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { SubLabel, SubTitle, Title } from "./styles";
import "./styles.css";
import { ButtonPrimary } from "../../ui/buttons";

function SuccessModal({ toggle, isOpen, backupCode }) {
  // revisar y ajustar el formato de backup code

  const backup = backupCode && typeof backupCode === "string" ? backupCode : "Código no disponible.";

  const handleCopyBackupCode = () => {
    try {
      navigator.clipboard.writeText(backupCode);
      toast.success("Codigo copiado!");
    } catch (error) {
      toast.error(`Error al copiar el codigo ${error}`);
    }
  };

  const handleDownloadBackupCode = () => {
    try {
      const fileName = "codigo_de_respaldo.txt";
      const element = document.createElement("a");
      const file = new Blob([backupCode], { type: "text/plain" });
      element.href = URL.createObjectURL(file);
      element.download = fileName;
      element.click();
      URL.revokeObjectURL(element.href);
      toast.success("Codigo descargado!");
    } catch (error) {
      toast.error(`Error al descargar el codigo ${error}`);
    }
  };

  return (
    <div>
      <Modal isOpen={isOpen} toggle={toggle} centered contentClassName="custom-modal">
        <ModalHeader className="border-0 pb- p-0" toggle={toggle} />
        <ModalBody className="p-0">
          <>
            <FontAwesomeIcon icon={faCircleCheck} className="mr-4 mb-2 w-100" color="#f0292a" size="4x" />
            <Title>¡La 2FA está activada!</Title>
            <div className="p-2 w-100 d-flex flex-column justify-content-center ">
              <SubTitle>Código de respaldo</SubTitle>
              <SubLabel>
                ¡Importante, esta es la única vez que podrás ver y guardar este código de respaldo! Sin él corres el riesgo de perder el acceso a tu cuenta si no dispones
                de tu aplicación de autenticación. Copialo y guardalo AHORA en tu dispositivo y fuera de él para reducir dicho riesgo.
              </SubLabel>
              <div
                className="d-flex flex-column align-items-center justify-content-center rounded p-4 mt-4 mx-auto"
                style={{ borderRadius: "8px", background: "#F7F7F7" }}
              >
                <div className="d-flex justify-content-around align-items-center">
                  <p className="m-1">{backup}</p>
                </div>
                <div>
                  <UncontrolledTooltip placement="left" target="btnCopy">
                    copiar
                  </UncontrolledTooltip>
                  <FontAwesomeIcon id="btnCopy" onClick={handleCopyBackupCode} icon={faCopy} className="m-2" color="#f0292a" style={{ cursor: "pointer" }} size="lg" />
                  <UncontrolledTooltip placement="right" target="btnDownload">
                    Descargar
                  </UncontrolledTooltip>
                  <FontAwesomeIcon
                    id="btnDownload"
                    onClick={handleDownloadBackupCode}
                    icon={faDownload}
                    className="m-2"
                    color="#f0292a"
                    style={{ cursor: "pointer" }}
                    size="lg"
                  />
                </div>
              </div>
            </div>
          </>
        </ModalBody>
        <ModalFooter className="border-0 pt-2">
          <ButtonPrimary onClick={toggle}>Finalizar</ButtonPrimary>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default SuccessModal;
